export const MenuItems = [
    {
        title: 'Padron',
        path: '/cigar/padron',
        cName: 'dropdown-link'
    },
    {
        title: 'Arturo Fuente',
        path: '/cigar/arturo-fuente',
        cName: 'dropdown-link'
    },
    {
        title: 'Oliva',
        path: '/cigar/oliva',
        cName: 'dropdown-link'
    },
    {
        title: 'Nub',
        path: '/cigar/nub',
        cName: 'dropdown-link'
    },
    {
        title: 'Cain',
        path: '/cigar/cain',
        cName: 'dropdown-link'
    },
    {
        title: 'La garela',
        path: '/cigar/la-garela',
        cName: 'dropdown-link'
    },
    {
        title: 'La Flor Dominicana',
        path: '/cigar/la-flor-dominicana',
        cName: 'dropdown-link'
    },
    {
        title: 'Ciboa',
        path: '/cigar/ciboa',
        cName: 'dropdown-link'
    }
];